import { Link, NavLink } from "react-router-dom";
import { useState, useEffect } from "react";
import { prefetchRouteByPath } from "../routes/prefetchRoutes";
import img from '../assets/images/AP-education-hub-logo-white.png'; // Your logo import
import {
  FaBars,
  FaTimes,
  FaChevronDown,
  FaChevronUp,
} from "react-icons/fa";

const Navbar = () => {
  const getViewportWidth = () =>
    typeof window === "undefined" ? 1200 : window.innerWidth;

  const [viewportWidth, setViewportWidth] = useState(getViewportWidth);
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isMobile, setIsMobile] = useState(getViewportWidth() <= 1024);
  const [desktopSchoolOpen, setDesktopSchoolOpen] = useState(false);
  const [mobileSchoolOpen, setMobileSchoolOpen] = useState(false);
  const [desktopInterOpen, setDesktopInterOpen] = useState(false);
  const [mobileInterOpen, setMobileInterOpen] = useState(false);
  const [desktopBtechOpen, setDesktopBtechOpen] = useState(false);
  const [mobileBtechOpen, setMobileBtechOpen] = useState(false);
  const [desktopDegreeOpen, setDesktopDegreeOpen] = useState(false);
  const [mobileDegreeOpen, setMobileDegreeOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };

    const checkScreenSize = () => {
      const width = window.innerWidth;
      const mobile = width <= 1024;
      setViewportWidth(width);
      setIsMobile(mobile);
      if (!mobile) {
        setOpen(false);
        setMobileSchoolOpen(false);
        setMobileInterOpen(false);
        setMobileBtechOpen(false);
        setMobileDegreeOpen(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", checkScreenSize);

    checkScreenSize();

    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", checkScreenSize);
    };
  }, []);

  useEffect(() => {
    if (!isMobile) return undefined;

    const previousOverflow = document.body.style.overflow;
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = previousOverflow || "";
    }

    return () => {
      document.body.style.overflow = previousOverflow || "";
    };
  }, [open, isMobile]);

  const schoolSubLinks = [
    { path: "/schools", label: "All Andhra Pradesh Schools" },
    { path: "/schools/ssc", label: "SSC Schools" },
    { path: "/schools/cbse", label: "CBSE Schools" },
    { path: "/schools/cisce", label: "CISCE Schools" },
    { path: "/schools/top-schools/all-boards", label: "Top Schools (All Boards)" },
    { path: "/schools/top-schools/cbse", label: "Top Schools CBSE" },
    { path: "/schools/top-schools/ssc", label: "Top Schools SSC" },
    { path: "/schools/top-schools/cisce", label: "Top Schools CISCE" },
    { path: "/schools/district/visakhapatnam", label: "Visakhapatnam District Schools" },
    { path: "/schools/district/vijayawada", label: "Vijayawada District Schools" },
    { path: "/schools/cbse/district/visakhapatnam", label: "Visakhapatnam CBSE Schools" },
    { path: "/schools/ssc/district/visakhapatnam", label: "Visakhapatnam SSC Schools" },
    { path: "/guides/what-is-ssc-board", label: "What is SSC Board?" },
    { path: "/guides/what-is-cbse-board", label: "What is CBSE Board?" },
    { path: "/guides/what-is-cisce-board", label: "What is CISCE Board?" },
    { path: "/guides", label: "All Guides" },
  ];

  const intermediateSubLinks = [
    { path: "/intermediate/colleges", label: "All Intermediate Colleges" },
    { path: "/intermediate/colleges/andhra-pradesh", label: "District-wise Intermediate Colleges" },
    { path: "/intermediate/colleges/andhra-pradesh/visakhapatnam/girls-colleges", label: "Girls Intermediate Colleges" },
    { path: "/why-mpc", label: "Why MPC Guide" },
    { path: "/why-bipc", label: "Why BiPC Guide" },
    { path: "/why-cec", label: "Why CEC Guide" },
    { path: "/why-mec", label: "Why MEC Guide" },
    { path: "/why-hec", label: "Why HEC Guide" },
    { path: "/top-10/mpc-colleges", label: "Top MPC Colleges" },
    { path: "/top-10/bipc-colleges", label: "Top BiPC Colleges" },
    { path: "/top-10/cec-colleges", label: "Top CEC Colleges" },
    { path: "/top-10/mec-colleges", label: "Top MEC Colleges" },
    { path: "/after-intermediate-next", label: "After Intermediate: What Next" },
    { path: "/after-intermediate/mpc", label: "After MPC Guide" },
    { path: "/after-intermediate/bipc", label: "After BiPC Guide" },
    { path: "/after-intermediate/cec", label: "After CEC Guide" },
    { path: "/after-intermediate/mec", label: "After MEC Guide" },
    { path: "/after-intermediate/hec", label: "After HEC Guide" },
    { path: "/guides", label: "All Guides" },
  ];

  const btechSubLinks = [
    { path: "/colleges/btech", label: "All Engineering Colleges" },
    { path: "/engineering-syllabus", label: "AP Engineering Syllabus" },
    { path: "/colleges/btech/district-wise", label: "District-wise Engineering Colleges" },
    { path: "/top-10/engineering-colleges", label: "Top Engineering Colleges" },
    { path: "/why-btech", label: "Why B.Tech Guide" },
    { path: "/why-cse", label: "Why CSE Guide" },
    { path: "/why-civil", label: "Why Civil Guide" },
    { path: "/why-mechanical", label: "Why Mechanical Guide" },
    { path: "/why-ece", label: "Why ECE Guide" },
    { path: "/why-eee", label: "Why EEE Guide" },
    { path: "/why-it", label: "Why IT Guide" },
    { path: "/why-aiml", label: "Why AI/ML Guide" },
    { path: "/why-data-science", label: "Why Data Science Guide" },
    { path: "/cse-vs-cse-aiml", label: "CSE vs CSE-AI/ML" },
    { path: "/guides", label: "All Guides" },
  ];

  const degreeSubLinks = [
    { path: "/colleges/degree", label: "All Degree Colleges" },
    { path: "/colleges/degree?district=HYDERABAD", label: "District-wise Degree Colleges" },
    { path: "/top-10/degree-colleges", label: "Top Degree Colleges" },
    { path: "/top-10/degree-bba-colleges", label: "Top BBA Colleges" },
    { path: "/top-10/degree-bcom-colleges", label: "Top B.Com Colleges" },
    { path: "/top-10/degree-bsc-colleges", label: "Top B.Sc Colleges" },
    { path: "/top-10/degree-ba-colleges", label: "Top BA Colleges" },
    { path: "/why-bba", label: "Why BBA Guide" },
    { path: "/why-bcom", label: "Why B.Com Guide" },
    { path: "/why-bsc", label: "Why B.Sc Guide" },
    { path: "/why-ba", label: "Why BA Guide" },
    { path: "/why-bca", label: "Why BCA Guide" },
    { path: "/courses/bba", label: "BBA Course Guide" },
    { path: "/courses/bcom", label: "B.Com Course Guide" },
    { path: "/courses/bsc", label: "B.Sc Course Guide" },
    { path: "/courses/ba", label: "BA Course Guide" },
    { path: "/courses/bca", label: "BCA Course Guide" },
    { path: "/guides", label: "All Guides" },
  ];

  const navLinks = [
    { path: "/eamcet", label: "EAMCET" },
    { path: "/results", label: "Results" },
    { path: "/advertise-with-us", label: "Advertise" },
    { path: "/contact-us", label: "Contact" },
  ];

  const getPrefetchHandlers = (path) => ({
    onMouseEnter: () => prefetchRouteByPath(path),
    onFocus: () => prefetchRouteByPath(path),
    onTouchStart: () => prefetchRouteByPath(path),
  });

  const isPhone = viewportWidth <= 768;
  const isSmallPhone = viewportWidth <= 480;
  const mobileMenuStyle = {
    ...styles.mobileMenu,
    ...(isPhone ? styles.mobileMenuPhone : styles.mobileMenuTablet),
  };
  const mobileSubMenuStyle = {
    ...styles.mobileSubMenu,
    ...(isPhone ? styles.mobileSubMenuPhone : styles.mobileSubMenuTablet),
    ...(isSmallPhone ? styles.mobileSubMenuSmallPhone : {}),
  };

  return (
    <header
      style={{
        ...styles.header,
        ...(scrolled ? styles.headerScrolled : {}),
      }}
    >
      <div style={styles.container}>
        {/* LOGO - Updated with imported image */}
        <div style={styles.logoContainer}>
          <Link to="/" style={styles.logo}>
            <div style={styles.logoImageContainer}>
              <img
                src={img}
                alt="Andhra Pradesh Education Hub Logo"
                style={styles.logoImage}
              />
            </div>
            <div style={styles.logoText}>
              <h3 style={styles.logoTitle}>Andhra Pradesh Education Hub</h3>
              {!isSmallPhone && (
                <p style={styles.logoSubtitle}>Complete School to Degree Guidance</p>
              )}
            </div>
          </Link>
        </div>

        {/* DESKTOP NAVIGATION */}
        {!isMobile ? (
          <nav style={styles.desktopMenu}>
            <NavLink
              to="/"
              {...getPrefetchHandlers("/")}
              style={({ isActive }) => ({
                ...styles.navLink,
                ...(isActive ? styles.activeNavLink : {}),
              })}
              className="navbar-nav-link"
            >
              <span style={styles.linkText}>Home</span>
            </NavLink>

            <div
              style={styles.dropdownWrap}
              onMouseEnter={() => setDesktopSchoolOpen(true)}
              onMouseLeave={() => setDesktopSchoolOpen(false)}
              onFocusCapture={() => setDesktopSchoolOpen(true)}
              onBlurCapture={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setDesktopSchoolOpen(false);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Escape") {
                  setDesktopSchoolOpen(false);
                }
              }}
            >
              <NavLink
                to="/schools"
                {...getPrefetchHandlers("/schools")}
                aria-haspopup="true"
                aria-expanded={desktopSchoolOpen}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.activeNavLink : {}),
                })}
                className="navbar-nav-link"
              >
                <span style={styles.linkText}>Schools</span>
                {desktopSchoolOpen ? <FaChevronUp style={styles.caretIcon} /> : <FaChevronDown style={styles.caretIcon} />}
              </NavLink>
              <div
                style={{
                  ...styles.dropdownMenu,
                  display: desktopSchoolOpen ? "block" : "none",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <div style={styles.megaGrid}>
                  {schoolSubLinks.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      {...getPrefetchHandlers(item.path)}
                      className="navbar-dropdown-link"
                      style={styles.dropdownLink}
                      onClick={() => setDesktopSchoolOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div
              style={styles.dropdownWrap}
              onMouseEnter={() => setDesktopInterOpen(true)}
              onMouseLeave={() => setDesktopInterOpen(false)}
              onFocusCapture={() => setDesktopInterOpen(true)}
              onBlurCapture={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setDesktopInterOpen(false);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Escape") {
                  setDesktopInterOpen(false);
                }
              }}
            >
              <NavLink
                to="/intermediate/colleges"
                {...getPrefetchHandlers("/intermediate/colleges")}
                aria-haspopup="true"
                aria-expanded={desktopInterOpen}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.activeNavLink : {}),
                })}
                className="navbar-nav-link"
              >
                <span style={styles.linkText}>Intermediate</span>
                {desktopInterOpen ? <FaChevronUp style={styles.caretIcon} /> : <FaChevronDown style={styles.caretIcon} />}
              </NavLink>
              <div
                style={{
                  ...styles.dropdownMenu,
                  display: desktopInterOpen ? "block" : "none",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <div style={styles.megaGrid}>
                  {intermediateSubLinks.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      {...getPrefetchHandlers(item.path)}
                      className="navbar-dropdown-link"
                      style={styles.dropdownLink}
                      onClick={() => setDesktopInterOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div
              style={styles.dropdownWrap}
              onMouseEnter={() => setDesktopBtechOpen(true)}
              onMouseLeave={() => setDesktopBtechOpen(false)}
              onFocusCapture={() => setDesktopBtechOpen(true)}
              onBlurCapture={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setDesktopBtechOpen(false);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Escape") {
                  setDesktopBtechOpen(false);
                }
              }}
            >
              <NavLink
                to="/colleges/btech"
                {...getPrefetchHandlers("/colleges/btech")}
                aria-haspopup="true"
                aria-expanded={desktopBtechOpen}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.activeNavLink : {}),
                })}
                className="navbar-nav-link"
              >
                <span style={styles.linkText}>B.Tech</span>
                {desktopBtechOpen ? <FaChevronUp style={styles.caretIcon} /> : <FaChevronDown style={styles.caretIcon} />}
              </NavLink>
              <div
                style={{
                  ...styles.dropdownMenu,
                  display: desktopBtechOpen ? "block" : "none",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <div style={styles.megaGrid}>
                  {btechSubLinks.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      {...getPrefetchHandlers(item.path)}
                      className="navbar-dropdown-link"
                      style={styles.dropdownLink}
                      onClick={() => setDesktopBtechOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            <div
              style={styles.dropdownWrap}
              onMouseEnter={() => setDesktopDegreeOpen(true)}
              onMouseLeave={() => setDesktopDegreeOpen(false)}
              onFocusCapture={() => setDesktopDegreeOpen(true)}
              onBlurCapture={(event) => {
                if (!event.currentTarget.contains(event.relatedTarget)) {
                  setDesktopDegreeOpen(false);
                }
              }}
              onKeyDown={(event) => {
                if (event.key === "Escape") {
                  setDesktopDegreeOpen(false);
                }
              }}
            >
              <NavLink
                to="/colleges/degree"
                {...getPrefetchHandlers("/colleges/degree")}
                aria-haspopup="true"
                aria-expanded={desktopDegreeOpen}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.activeNavLink : {}),
                })}
                className="navbar-nav-link"
              >
                <span style={styles.linkText}>Degree</span>
                {desktopDegreeOpen ? <FaChevronUp style={styles.caretIcon} /> : <FaChevronDown style={styles.caretIcon} />}
              </NavLink>
              <div
                style={{
                  ...styles.dropdownMenu,
                  display: desktopDegreeOpen ? "block" : "none",
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
              >
                <div style={styles.megaGrid}>
                  {degreeSubLinks.map((item) => (
                    <Link
                      key={item.path}
                      to={item.path}
                      {...getPrefetchHandlers(item.path)}
                      className="navbar-dropdown-link"
                      style={styles.dropdownLink}
                      onClick={() => setDesktopDegreeOpen(false)}
                    >
                      {item.label}
                    </Link>
                  ))}
                </div>
              </div>
            </div>

            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                {...getPrefetchHandlers(link.path)}
                style={({ isActive }) => ({
                  ...styles.navLink,
                  ...(isActive ? styles.activeNavLink : {}),
                })}
                className="navbar-nav-link"
              >
                <span style={styles.linkText}>{link.label}</span>
              </NavLink>
            ))}
          </nav>
        ) : (
          /* MOBILE HAMBURGER */
          <button
            type="button"
            style={styles.hamburger}
            className="navbar-hamburger"
            onClick={() => setOpen((prev) => !prev)}
            aria-label={open ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={open}
            aria-controls="navbar-mobile-menu"
          >
            {open ? <FaTimes /> : <FaBars />}
          </button>
        )}
      </div>

      {/* MOBILE MENU */}
      {open && isMobile && (
        <>
          <div
            style={styles.mobileBackdrop}
            onClick={() => {
              setOpen(false);
              setMobileSchoolOpen(false);
              setMobileInterOpen(false);
              setMobileBtechOpen(false);
              setMobileDegreeOpen(false);
            }}
          />
          <div id="navbar-mobile-menu" style={mobileMenuStyle}>
            <div style={styles.mobileNav}>
              <NavLink
                to="/"
                {...getPrefetchHandlers("/")}
                style={({ isActive }) => ({
                  ...styles.mobileLink,
                  ...(isActive ? styles.mobileActiveLink : {}),
                })}
                className="navbar-mobile-link"
                onClick={() => setOpen(false)}
              >
                <span style={styles.mobileLinkText}>Home</span>
              </NavLink>

              <button
                type="button"
                style={styles.mobileInterToggle}
                onClick={() => setMobileSchoolOpen((prev) => !prev)}
                className="navbar-mobile-toggle"
                aria-expanded={mobileSchoolOpen}
                aria-controls="mobile-schools-submenu"
              >
                <span style={styles.mobileLinkText}>Schools</span>
                {mobileSchoolOpen ? <FaChevronUp style={styles.mobileCaretIcon} /> : <FaChevronDown style={styles.mobileCaretIcon} />}
              </button>

              {mobileSchoolOpen && (
                <div id="mobile-schools-submenu" style={mobileSubMenuStyle}>
                  <NavLink
                    to="/schools"
                    {...getPrefetchHandlers("/schools")}
                    style={styles.mobileSubLink}
                    onClick={() => {
                      setOpen(false);
                      setMobileSchoolOpen(false);
                    }}
                  >
                    All Andhra Pradesh Schools
                  </NavLink>
                  {schoolSubLinks
                    .filter((item) => item.path !== "/schools")
                    .map((item) => (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        {...getPrefetchHandlers(item.path)}
                        style={styles.mobileSubLink}
                        onClick={() => {
                          setOpen(false);
                          setMobileSchoolOpen(false);
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                </div>
              )}

              <button
                type="button"
                style={styles.mobileInterToggle}
                onClick={() => setMobileInterOpen((prev) => !prev)}
                className="navbar-mobile-toggle"
                aria-expanded={mobileInterOpen}
                aria-controls="mobile-inter-submenu"
              >
                <span style={styles.mobileLinkText}>Intermediate</span>
                {mobileInterOpen ? <FaChevronUp style={styles.mobileCaretIcon} /> : <FaChevronDown style={styles.mobileCaretIcon} />}
              </button>

              {mobileInterOpen && (
                <div id="mobile-inter-submenu" style={mobileSubMenuStyle}>
                  <NavLink
                    to="/intermediate/colleges"
                    {...getPrefetchHandlers("/intermediate/colleges")}
                    style={styles.mobileSubLink}
                    onClick={() => {
                      setOpen(false);
                      setMobileInterOpen(false);
                    }}
                  >
                    View All Intermediate Colleges
                  </NavLink>
                  {intermediateSubLinks
                    .filter((item) => item.path !== "/intermediate/colleges")
                    .map((item) => (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        {...getPrefetchHandlers(item.path)}
                        style={styles.mobileSubLink}
                        onClick={() => {
                          setOpen(false);
                          setMobileInterOpen(false);
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                </div>
              )}

              <button
                type="button"
                style={styles.mobileInterToggle}
                onClick={() => setMobileBtechOpen((prev) => !prev)}
                className="navbar-mobile-toggle"
                aria-expanded={mobileBtechOpen}
                aria-controls="mobile-btech-submenu"
              >
                <span style={styles.mobileLinkText}>B.Tech</span>
                {mobileBtechOpen ? <FaChevronUp style={styles.mobileCaretIcon} /> : <FaChevronDown style={styles.mobileCaretIcon} />}
              </button>

              {mobileBtechOpen && (
                <div id="mobile-btech-submenu" style={mobileSubMenuStyle}>
                  <NavLink
                    to="/colleges/btech"
                    {...getPrefetchHandlers("/colleges/btech")}
                    style={styles.mobileSubLink}
                    onClick={() => {
                      setOpen(false);
                      setMobileBtechOpen(false);
                    }}
                  >
                    View All Engineering Colleges
                  </NavLink>
                  {btechSubLinks
                    .filter((item) => item.path !== "/colleges/btech")
                    .map((item) => (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        {...getPrefetchHandlers(item.path)}
                        style={styles.mobileSubLink}
                        onClick={() => {
                          setOpen(false);
                          setMobileBtechOpen(false);
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                </div>
              )}

              <button
                type="button"
                style={styles.mobileInterToggle}
                onClick={() => setMobileDegreeOpen((prev) => !prev)}
                className="navbar-mobile-toggle"
                aria-expanded={mobileDegreeOpen}
                aria-controls="mobile-degree-submenu"
              >
                <span style={styles.mobileLinkText}>Degree</span>
                {mobileDegreeOpen ? <FaChevronUp style={styles.mobileCaretIcon} /> : <FaChevronDown style={styles.mobileCaretIcon} />}
              </button>

              {mobileDegreeOpen && (
                <div id="mobile-degree-submenu" style={mobileSubMenuStyle}>
                  <NavLink
                    to="/colleges/degree"
                    {...getPrefetchHandlers("/colleges/degree")}
                    style={styles.mobileSubLink}
                    onClick={() => {
                      setOpen(false);
                      setMobileDegreeOpen(false);
                    }}
                  >
                    View All Degree Colleges
                  </NavLink>
                  {degreeSubLinks
                    .filter((item) => item.path !== "/colleges/degree")
                    .map((item) => (
                      <NavLink
                        key={item.path}
                        to={item.path}
                        {...getPrefetchHandlers(item.path)}
                        style={styles.mobileSubLink}
                        onClick={() => {
                          setOpen(false);
                          setMobileDegreeOpen(false);
                        }}
                      >
                        {item.label}
                      </NavLink>
                    ))}
                </div>
              )}

              {navLinks.map((link) => (
                <NavLink
                  key={link.path}
                  to={link.path}
                  {...getPrefetchHandlers(link.path)}
                  style={({ isActive }) => ({
                    ...styles.mobileLink,
                    ...(isActive ? styles.mobileActiveLink : {}),
                  })}
                  className="navbar-mobile-link"
                  onClick={() => setOpen(false)}
                >
                  <span style={styles.mobileLinkText}>{link.label}</span>
                </NavLink>
              ))}
            </div>

          </div>
        </>
      )}

      {/* Announcement Bar */}

    </header>
  );
};

const styles = {
  header: {
    background: "linear-gradient(135deg, #2E7D32 0%, #1B5E20 100%)",
    color: "#fff",
    position: "sticky",
    top: 0,
    zIndex: 1000,
    boxShadow: "0 2px 20px rgba(0, 0, 0, 0.1)",
    transition: "all 0.3s ease",
    width: "100%",
    overflow: "visible",
    minHeight: "72px",
  },

  container: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    padding: "12px 20px",
    maxWidth: "1200px",
    margin: "0 auto",
    width: "100%",
    boxSizing: "border-box",
  },

  logoIcon: {
    fontSize: "2rem",
    background: "rgba(255, 255, 255, 0.1)",
    padding: "10px",
    borderRadius: "10px",
    color: "#fff",
  },

  desktopMenu: {
    display: "flex",
    alignItems: "center",
    gap: "4px",
    flexWrap: "nowrap",
  },

  dropdownWrap: {
    position: "relative",
  },

  dropdownMenu: {
    position: "absolute",
    top: "100%",
    left: "-120px",
    width: "760px",
    maxWidth: "calc(100vw - 40px)",
    background: "#f8fbfa",
    border: "1px solid #e2e8f0",
    borderRadius: "12px",
    boxShadow: "0 12px 28px rgba(0,0,0,0.16)",
    padding: "12px",
    display: "none",
    zIndex: 30,
  },

  megaGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
    gap: "2px 14px",
  },

  dropdownLink: {
    display: "block",
    textDecoration: "none",
    color: "#1f2937",
    fontSize: "0.9rem",
    fontWeight: "500",
    padding: "6px 2px",
    background: "transparent",
    border: "none",
    borderRadius: "0",
    transition: "transform 0.2s ease, color 0.2s ease",
  },

  navLink: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
    color: "rgba(255, 255, 255, 0.9)",
    textDecoration: "none",
    fontSize: "0.8rem",
    padding: "9px 12px",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    whiteSpace: "nowrap",
  },

  activeNavLink: {
    background: "rgba(255, 255, 255, 0.15)",
    color: "#fff",
    fontWeight: "600",
  },

  linkText: {
    display: "inline-block",
  },

  caretIcon: {
    fontSize: "0.72rem",
    opacity: 0.9,
  },

  hamburger: {
    fontSize: "1.5rem",
    cursor: "pointer",
    padding: "8px",
    background: "rgba(255, 255, 255, 0.1)",
    borderRadius: "8px",
    transition: "all 0.3s ease",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    border: "none",
    color: "inherit",
  },

  mobileMenu: {
    position: "fixed",
    top: "72px",
    left: 0,
    right: 0,
    bottom: 0,
    background: "linear-gradient(135deg, #1B5E20 0%, #2E7D32 100%)",
    padding: "20px",
    borderTop: "1px solid rgba(255, 255, 255, 0.1)",
    animation: "slideDown 0.3s ease",
    width: "100%",
    boxSizing: "border-box",
    overflowY: "auto",
    zIndex: 998,
  },
  mobileMenuTablet: {
    left: "auto",
    width: "min(430px, 88vw)",
    borderLeft: "1px solid rgba(255, 255, 255, 0.18)",
    boxShadow: "-10px 0 24px rgba(0, 0, 0, 0.28)",
  },
  mobileMenuPhone: {
    left: 0,
    right: 0,
    width: "100%",
    borderLeft: "none",
    boxShadow: "none",
  },

  mobileBackdrop: {
    position: "fixed",
    top: "72px",
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(2, 6, 23, 0.45)",
    zIndex: 997,
  },

  mobileNav: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
    marginBottom: "20px",
    width: "100%",
  },

  mobileInterToggle: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "rgba(255, 255, 255, 0.9)",
    background: "transparent",
    border: "none",
    padding: "12px 20px",
    borderRadius: "10px",
    width: "100%",
    textAlign: "left",
    cursor: "pointer",
    justifyContent: "space-between",
  },

  mobileSubMenu: {
    margin: "-4px 0 8px 38px",
    display: "grid",
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
    gap: "8px",
    width: "calc(100% - 38px)",
  },
  mobileSubMenuTablet: {
    gridTemplateColumns: "repeat(3, minmax(0, 1fr))",
  },
  mobileSubMenuPhone: {
    gridTemplateColumns: "repeat(2, minmax(0, 1fr))",
  },
  mobileSubMenuSmallPhone: {
    width: "100%",
    marginLeft: 0,
  },

  mobileSubLink: {
    textDecoration: "none",
    color: "#dcfce7",
    fontSize: "0.8rem",
    border: "1px solid rgba(255,255,255,0.12)",
    borderRadius: "8px",
    padding: "8px 10px",
    lineHeight: "1.25",
  },

  mobileLink: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    color: "rgba(255, 255, 255, 0.9)",
    textDecoration: "none",
    padding: "12px 20px",
    borderRadius: "10px",
    transition: "all 0.3s ease",
    width: "100%",
    boxSizing: "border-box",
  },

  mobileActiveLink: {
    background: "rgba(255, 255, 255, 0.15)",
    color: "#fff",
    fontWeight: "600",
  },

  mobileLinkText: {
    fontSize: "1rem",
  },

  mobileCaretIcon: {
    marginLeft: "auto",
    fontSize: "0.8rem",
    opacity: 0.95,
  },



  logoContainer: {
    display: "flex",
    alignItems: "center",
  },
  logo: {
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    color: "inherit",
    gap: "6px",
  },
  logoImageContainer: {
    width: "46px",
    height: "46px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  logoImage: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
    borderRadius: "4px",
  },
  logoText: {
    display: "flex",
    flexDirection: "column",
  },
  logoTitle: {
    margin: 0,
    fontSize: "clamp(1.05rem, 1.9vw, 1.45rem)",
    fontWeight: "bold",
    color: "white",
    letterSpacing: "0.1px",
    lineHeight: "1.15",
    maxWidth: "320px",
  },
  logoSubtitle: {
    margin: 0,
    fontSize: "0.72rem",
    color: "white",
    opacity: 0.9,
    lineHeight: "1.1",
  },

  announcement: {
    background: "#fef3c7",
    padding: "8px 10px",
    borderTop: "1px solid #fde68a",
    width: "100%",
    boxSizing: "border-box",
  },

  announcementInner: {
    maxWidth: "1200px",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: "10px",
    flexWrap: "wrap",
  },

  announcementText: {
    fontSize: "0.86rem",
    color: "#92400e",
    fontWeight: "600",
    lineHeight: "1.4",
  },

  announcementCta: {
    textDecoration: "none",
    border: "1px solid #f59e0b",
    background: "#f59e0b",
    color: "#ffffff",
    borderRadius: "8px",
    padding: "6px 10px",
    fontSize: "0.82rem",
    fontWeight: "700",
  },

};

// Add CSS animations without touching stylesheet cssRules (avoids cross-origin/runtime errors).
if (typeof document !== "undefined") {
  const navbarCss = `
    @keyframes slideDown {
      from {
        opacity: 0;
        transform: translateY(-10px);
      }
      to {
        opacity: 1;
        transform: translateY(0);
      }
    }
    .navbar-dropdown-link:hover {
      color: #16a34a !important;
      transform: translateX(3px);
    }
    .navbar-nav-link:hover {
      background: rgba(255, 255, 255, 0.1) !important;
      color: #fff !important;
    }
    .navbar-hamburger:hover {
      background: rgba(255, 255, 255, 0.2) !important;
    }
    .navbar-mobile-link:hover,
    .navbar-mobile-toggle:hover {
      background: rgba(255, 255, 255, 0.1) !important;
      color: #fff !important;
    }
  `;

  let styleEl = document.getElementById("navbar-keyframes");
  if (!styleEl) {
    styleEl = document.createElement("style");
    styleEl.id = "navbar-keyframes";
    document.head.appendChild(styleEl);
  }

  if (styleEl.textContent !== navbarCss) {
    styleEl.textContent = navbarCss;
  }
}

export default Navbar;
